const HorizontalLine = () => (
  <hr className="w-full h-[1px] text-gray-200 px-6" />
);

export default HorizontalLine;
